import { useDispatch, useSelector } from 'react-redux';
import { setResourcesAction } from './inputs.actions';

const useInputsResources = () => {
  const state = useSelector((state: any) => state.InputsResources);

  const dispatch = useDispatch();

  const setResources = (payload) => {
    dispatch(setResourcesAction(payload));
  };

  return { state, setResources };
};

export default useInputsResources;
